import type { InformationSectionProps } from "./information-section.type";

import { Typography } from "antd";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { InformationSectionIcon } from "./information-section-icon";

import "./information-section.style.less";

const { Title } = Typography;

export const InformationSection = ({
  type = "info",
  title,
  children,
}: InformationSectionProps) => {
  const { t } = useTranslation();

  return (
    <div className={classNames("information-section", `-${type}`)}>
      <div className="information-section-header">
        <div className="information-section-icon">
          <InformationSectionIcon type={type} />
        </div>
        <Title level={3}>
          {title ?? t(`global:informationSection.${type}`)}
        </Title>
        <div className="information-section-line" />
      </div>
      <div className="information-section-content">{children}</div>
    </div>
  );
};
